import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#050c17] text-gray-400 py-14 border-t border-white/10 pb-28 md:pb-14">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 flex flex-col items-center text-center">
        <h3 className="font-serif text-2xl text-white font-bold mb-2">Der Dividenden-Investor</h3>
        <p className="font-sans text-sm mb-8 max-w-xl text-gray-500">
          Ein Leitfaden für monatliches Einkommen an der Börse.
        </p>

        <div className="w-16 h-px bg-gold/30 mb-8"></div>

        <div className="bg-white/5 border border-white/10 rounded-xl px-6 py-4 mb-8 max-w-2xl">
          <p className="font-sans text-xs text-gray-400 leading-relaxed">
            <span className="text-gold font-semibold">Amazon Affiliate Disclosure: </span>
            Als Amazon-Partner verdiene ich an qualifizierten Verkäufen. Wenn Sie auf einen
            Affiliate-Link klicken und über diesen Link einkaufen, bekomme ich eine Provision.
            Für Sie verändert sich der Preis nicht.
          </p>
        </div>

        <div className="flex gap-6 md:gap-8 font-sans text-sm mb-8">
          <Link to="/impressum" className="hover:text-gold transition-colors duration-200">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-gold transition-colors duration-200">Datenschutz</Link>
          <Link to="/kontakt" className="hover:text-gold transition-colors duration-200">Kontakt</Link>
        </div>

        <p className="font-sans text-xs text-gray-600">
          &copy; {new Date().getFullYear()} Marc Arndt. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};